import { render } from "./LoginView.vue?vue&type=template&id=6054dbb8&scoped=true"
import script from "@/controllers/loginController.js?vue&type=script&lang=js"
export * from "@/controllers/loginController.js?vue&type=script&lang=js"

import "./LoginView.vue?vue&type=style&index=0&id=6054dbb8&scoped=true&lang=css"

import exportComponent from "/home/jocelino/IGAMES-PS2/panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6054dbb8"]])

export default __exports__